import { createFileRoute } from "@tanstack/react-router"

export const Route = createFileRoute(
  "/_layout/settings/_panel/workspace/roles/_list/",
)({
  component: Empty,
})

function Empty(): React.ReactElement {
  return <span />
}
